/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TextSize {
  SmallBody = 'SmallBody',
  Body = 'Body',
  LargeBody = 'LargeBody',
  SmallTitle = 'SmallTitle',
  Title = 'Title'
}
